<template>
    <div v-if="records">

            <b-field label="Label names (press Enter to add)" message="Add at least two labels for binary classification.">
                <b-taginput
                    size="is-medium"
                    type="is-info"
                    expanded
                    v-model="labels"
                    :allow-new="true"
                    :open-on-focus="true"
                    :autocomplete="true"
                    :data="project.label_suggestions"
                    @close="addLabel"
                    @input="addLabel"
                    placeholder="➕ Add a label">
                </b-taginput>
            </b-field>
        

            <br>
            <!-- <b-field label="LLM Labeling" message="Get help labeling your data with LLM, you'll validate the output">
                <b-button>
                    <svg xmlns="http://www.w3.org/2000/svg" height="11" width="13" viewBox="0 0 576 512"><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
                    Apply AutoLabel with LLM
                </b-button>
            </b-field>
            <br> -->
            <!-- Count by productDocuments by label ocorrence -->
            
            <b>Unlabeled records</b>
            <table class="table is-fullwidth is-striped is-hoverable">
                <!-- <thead>
                    <tr>
                        
                    </tr>
                </thead> -->
                <tbody>
                    <tr v-for="label in [...records.filter( i => !labels.includes(i.label)).map(({ label }) => label).filter((value, index, array) => array.indexOf(value) === index)].filter((value, index, array) => array.indexOf(value) === index)">
                        <td>{{ (!label?'Unlabeled':label) }}</td>
                        <td>{{ records.filter(doc => doc.label == label).length }}</td>
                    </tr>
                </tbody>
                
                <b-field message="Filter your data by Unlabeled to see this records">
                </b-field>
            </table>
            
            
            
            

    </div>
</template>
<script>
    
export default {
       props: ["project", "records"],
      data() {
        return {
          new_label: null,
          labels: []
        };
      },
      mounted() {
        this.labels = this.project.labels.map(({ label }) => label)
      },
      computed: {

      },
      methods: {
            addLabel(){

                let new_labels = []
                this.labels.forEach(function (label, idx) {
                    new_labels.push({label_code: idx+1, label: label})
                })
                
                let update = {
                    labels: new_labels
                }

                this.project.labels = new_labels

                const toUpdate = {
                    projectId: this.project.id,
                    update: update
                }
                
                this.$store.dispatch("updateProject", 
                    toUpdate
                )
            }
        }
    }
    </script>